import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import './index.css'
import { NotAuthenticated } from './lib/api'
import { SessionProvider } from './session'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Amounts and balances go stale the moment the other member touches them,
      // so a cache that survives a tab switch would show a wrong balance.
      staleTime: 0,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) =>
        // An expired session is not a transient failure: retrying it three times
        // just delays the redirect to /login.
        error instanceof NotAuthenticated ? false : failureCount < 2,
    },
    // Mutations are never retried automatically. Every one of them is guarded by
    // an `expectedRevision`, so a retry either 409s or -- worse, if the first
    // attempt actually landed -- applies the change twice.
    mutations: { retry: false },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
